import { css } from '@emotion/css';

export const wordBreakBreakWord = css`
  word-break: break-word;
`;
